import { getErrorMessage, isAPIError } from "@/core/services";
import type { ToastApi } from "@/ds";
import { updatePermission } from "@/modules/permissions";
import type { Permission } from "@/modules/permissions";
import {
  UPDATE_ERROR_MESSAGE,
  UPDATE_FORBIDDEN_MESSAGE,
  UPDATE_SUCCESS_MESSAGE,
} from "../permissions.constants";

export interface PermissionEditValues {
  readonly nome: string;
  readonly descricao: string;
}

interface UsePermissionsAtualizacaoParams {
  readonly toast: ToastApi;
  /** Sucesso: a tela fecha o modal e refaz a consulta. */
  readonly onUpdated: () => void;
}

/** Model da edição (HU 902): só nome e descrição saem do formulário (RN01); o código segue o da linha (RN02). */
export function usePermissionsAtualizacao({ toast, onUpdated }: UsePermissionsAtualizacaoParams) {
  /** Nunca rejeita: a falha mantém o modal aberto com os dados digitados. */
  return async (permission: Permission, values: PermissionEditValues): Promise<void> => {
    try {
      await updatePermission({ id: permission.id, ...values });
    } catch (error) {
      const isForbidden = isAPIError(error) && error.status === 403;

      toast.error(
        isForbidden ? "Acesso não autorizado" : UPDATE_ERROR_MESSAGE,
        isForbidden ? UPDATE_FORBIDDEN_MESSAGE : getErrorMessage(error),
      );
      return;
    }

    onUpdated();
    toast.success("Sucesso", UPDATE_SUCCESS_MESSAGE);
  };
}
